/**
 * PDF component module.
 * @module shared/components/PDF
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

const _PDF = styled.object`
  width: 100%;
  height: 80vh;
  flex-grow: 1;
  background: url("https://www.wpfaster.org/wp-content/uploads/2013/06/circle-loading-gif.gif") center center no-repeat;
`;

const PDF = props => {
  const {uri} = props;

  return <_PDF type={'application/pdf'} data={uri}/>;
};

export default PDF;

PDF.propTypes = {
  /**
   * PDF uri
   */
  uri: PropTypes.string.isRequired,
};
